import React, { Component } from 'react'

import CompanyLogo from '../_presentational/icon/CompanyLogo'
import Button from '../_presentational/Button/Button'

import { LandingPageContainer, MessageContainer, ButtonContainer } from './LandingPage-styled'

// export default ({ goToMyDashboard }) => {
export default class LandingPage extends Component {
  state = {
    going: false,
  }

  clickGo = () => {
    if (!this.state.going) {
      this.setState(
        {
          going: true,
        },
        () => {
          setTimeout(() => {
            this.props.goToMyDashboard()
          }, 400)
        },
      )
    }
  }

  renderLetsGoButton = ({ going }) => (
    <ButtonContainer key={`going-${going}`} going={going}>
      <Button onClick={this.clickGo} title="Let's Go!" type="alternative" fullWidth large />
    </ButtonContainer>
  )

  render() {
    const { going } = this.state
    return (
      <LandingPageContainer>
        <MessageContainer>
          <CompanyLogo orientation="portrait" />
          {going && this.renderLetsGoButton({ going })}
          {!going && this.renderLetsGoButton({ going })}
        </MessageContainer>
      </LandingPageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/LandingPage/LandingPage.jsx